<template>
  <div class="admin-permission">
    <el-card shadow="hover">
      <template #header>
        <div class="card-header">
          <span>权限管理</span>
          <el-button type="primary" @click="handleAdd">添加权限</el-button>
        </div>
      </template>
      <el-tree
        :data="permissionTree"
        node-key="id"
        default-expand-all
        @node-click="handleNodeClick"
      >
        <template #default="{ node, data }">
          <span class="custom-tree-node">
            <span>{{ data.name }}</span>
            <span class="node-actions">
              <el-button size="mini" @click="handleEdit(data)">编辑</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(data.id)">删除</el-button>
            </span>
          </span>
        </template>
      </el-tree>
    </el-card>

    <!-- 添加/编辑权限对话框 -->
    <el-dialog v-model="dialogVisible" :title="dialogTitle" width="500px">
      <el-form ref="formRef" :model="form" :rules="formRules" label-width="80px">
        <el-form-item label="权限名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入权限名称"></el-input>
        </el-form-item>
        <el-form-item label="权限代码" prop="code">
          <el-input v-model="form.code" placeholder="请输入权限代码"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="form.description" type="textarea" placeholder="请输入权限描述"></el-input>
        </el-form-item>
        <el-form-item label="父权限">
          <el-select v-model="form.parent_id" placeholder="请选择父权限">
            <el-option label="顶级权限" value="0"></el-option>
            <el-option v-for="permission in permissionList" :key="permission.id" :label="permission.name" :value="permission.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AdminPermission',
  data() {
    return {
      permissionTree: [],
      permissionList: [],
      dialogVisible: false,
      dialogTitle: '添加权限',
      form: {},
      formRules: {
        name: [{ required: true, message: '请输入权限名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入权限代码', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.fetchPermissionList()
  },
  methods: {
    // 获取权限列表
    fetchPermissionList() {
      try {
        const token = localStorage.getItem('adminToken')
        fetch('/api/admin/permission/list', {
          headers: { 'Authorization': `Bearer ${token}` }
        })
        .then(response => response.json())
        .then(data => {
          if (data.code === 0) {
            this.permissionTree = data.data
            // 扁平化为列表用于选择
            this.permissionList = this.flattenTree(data.data)
          }
        })
      } catch (error) {
        this.$message.error('获取权限列表失败')
      }
    },

    // 扁平化树结构
    flattenTree(tree) {
      let result = []
      tree.forEach(node => {
        result.push(node)
        if (node.children && node.children.length > 0) {
          result = result.concat(this.flattenTree(node.children))
        }
      })
      return result
    },

    // 节点点击事件
    handleNodeClick(data) {
      console.log('点击节点:', data)
    },

    // 添加权限
    handleAdd() {
      this.dialogTitle = '添加权限'
      Object.assign(this.form, {
        name: '',
        code: '',
        description: '',
        parent_id: 0
      })
      this.dialogVisible = true
    },

    // 编辑权限
    handleEdit(data) {
      this.dialogTitle = '编辑权限'
      Object.assign(this.form, { ...data })
      this.dialogVisible = true
    },

    // 提交表单
    handleSubmit() {
      try {
        this.$refs.formRef.validate((valid) => {
          if (valid) {
            const token = localStorage.getItem('adminToken')
            const url = this.form.id ? '/api/admin/permission/update' : '/api/admin/permission/create'
            fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
              },
              body: JSON.stringify(this.form)
            })
            .then(response => response.json())
            .then(data => {
              if (data.code === 0) {
                this.$message.success(this.form.id ? '更新成功' : '添加成功')
                this.dialogVisible = false
                this.fetchPermissionList()
              } else {
                this.$message.error(data.message)
              }
            })
          }
        })
      } catch (error) {
        this.$message.error('操作失败')
      }
    },

    // 删除权限
    handleDelete(id) {
      this.$confirm('确定要删除该权限吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const token = localStorage.getItem('adminToken')
        fetch('/api/admin/permission/delete', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ id })
        })
        .then(response => response.json())
        .then(data => {
          if (data.code === 0) {
            this.$message.success('删除成功')
            this.fetchPermissionList()
          } else {
            this.$message.error(data.message)
          }
        })
      }).catch(() => {
        // 用户取消删除
      })
    }
  }
}
</script>

<style scoped>
.admin-permission {
  width: 100%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.custom-tree-node {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 16px 0;
  min-height: 56px;
}

.node-actions {
  display: flex;
  gap: 10px;
}

.node-actions .el-button {
  padding: 6px 12px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
